var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./ExpansionView.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d82ee8b4\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./ExpansionView.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/ExpansionView.vue
// module id = 385
// module chunks = 1